import config from '../../config'

import useIsAuthenticated from '../../customhooks/useIsAuthenticated'

const SkipAdsModal = ({ show, setShowSkipAdsModal, slugUrl }) => {
    const isAuthenticated = useIsAuthenticated()

    return (
        <div className={`modal fade ${show && 'show d-block'}`} tabIndex="-1">
            <div className="modal-dialog modal-dialog-centered ">
                <div className="modal-content border-0">
                    <div className="modal-header border-0">
                        {/* <h1 className="modal-title fs-5" id="exampleModalLabel">Modal title</h1> */}
                        <button type="button" className="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"
                        onClick={() => setShowSkipAdsModal(false)}
                        ></button>
                    </div>

                    <div className="modal-body border-0">
                        <h1 className="fs-5 fw-bold">You're getting this content for <span className='special-text'>free</span>!</h1>
                        <p>You'll need to pass through an ad-link to access this content. Follow the following steps:</p>

                        <p className="m-0">1. Click "Continue with Ads"</p>
                        <p className="m-0">2. Click "Get Link"</p>
                        <p className="m-0">3. Complete or skip optional steps</p>
                        <p className="mb-3">4. Access your content</p>

                        <a href={`/generate-download/${slugUrl}`} className="btn btn-primary w-100">Continue with Ads</a>

                        {isAuthenticated &&
                            <p className="text-center">
                                You will earn <span className="special-text">+1 point</span> for this download.
                            </p>
                        }

                        {!isAuthenticated &&
                            <p className="text-center">
                                <a href={config.MAGICPOINTS_WEBSITE_URL + '/register?source=magicfans'} target={'_blank'}>Sign up</a> and earn <span className="special-text">+1 point</span> for every content you download.
                            </p>
                        }

                    </div>

                    <div className="modal-footer border-0">
                        {/* <button type="button" className="btn btn-primary w-100">Continue with Ads</button> */}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SkipAdsModal
